export default function isPartnersZoneEnabled() {
    return process.env.PARTNERS_ZONE_ENABLE === '1';
}
